module.exports = __webpack_public_path__ + "static/mentor-mausumi-69da8f17d6db7f93db8d1434678c1b53.jpg";